// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2WXkm","content":"Consent_content__3itPI","footer":"Consent_footer__V3LKy"};